import React, { useState } from 'react'
import { Modal, Collapse, Row, Col, Switch, Button } from 'antd'
import Map from 'components/Map';
import { DownOutlined } from '@ant-design/icons';
import timeIcon from './img/time.png';
import speedIcon from './img/speed.png';
import batteryIcon from './img/battery.png';
import ring from './img/ring-icon.png';

const { Panel } = Collapse;

const defaultPos = [35.7115, 51.4074]
const zoomLevel = 16


export default function CurrentRideView({ finishRide, rideFinishing=false,
    vehicleDetails, lockLoading, lockChange,
    settingLoading, changeLights, playBeep,
    speed, rideTime, vehicleLock, vehicleLightsOn,
    vehiclesPos }) {

    const [confirmFinish, setConfirmFinish] = useState(false)
    const [activePanel, setActivePanel] = useState(null)

    const showConfirmFinish = () => {
        setActivePanel(null)
        setConfirmFinish(true)
    }
    return <>
        <Modal
            className='end-ride-modal'
            title="پایان سفر"
            visible={confirmFinish}
            onOk={finishRide}
            onCancel={e => { setConfirmFinish(false) }}
            okText="پایان سفر"
            cancelText="بازگشت"
            confirmLoading={rideFinishing}
            closable={false}>
            آیا از پایان سفر مطمئن هستید؟
        </Modal>
        <div className='current-ride-container'>
            <Collapse bordered={false} className='bg-white current-ride-collapse'
                expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 0 : 180} />}
                activeKey={activePanel}
                onChange={(key => setActivePanel(key))}>
                <Panel disabled={confirmFinish} key="ride-more"
                    header={<Row className='' style={{ textAlign: 'center' }}>

                        <Col span={8} className='current-ride-item'>
                            <img src={timeIcon} className='current-ride-icon' alt="" />
                            <span className='current-ride-info-text f-30'>{rideTime}</span>
                        </Col>
                        <Col span={8} className='current-ride-item'>
                            {/* <img src={speedIcon} className='current-ride-icon' alt="" />
                            <span className='current-ride-info-text f-30'>
                                {speed}
                            </span>
                            <span className='current-ride-info-text f-18'>kpm</span> */}
                        </Col>
                        <Col span={8} className='current-ride-item'>
                            <img src={batteryIcon} className='current-ride-icon' alt="" />
                            <span className='current-ride-info-text f-30'>
                                {vehicleDetails !== undefined ? vehicleDetails.batteryPercent : 0}</span>
                            <span className='current-ride-info-text f-18'>%</span>
                        </Col>
                    </Row>}>
                    <Col span={24} className='pt-2 pb-1'>
                        <Row className='mb-1'>
                            <div>
                                قفل موقت اسکوتر
                    </div>
                            <Switch className='current-ride-switch'
                                loading={lockLoading}
                                checked={vehicleLock}
                                onClick={lockChange} />
                        </Row>
                        <Row className='mb-1'>
                            <div>
                                روشن کردن چراغ‌ها
                    </div>
                                <Switch className='current-ride-switch' checked={vehicleLightsOn}
                                    loading={settingLoading}
                                    onClick={() => changeLights()} />

                        </Row>
                        <Row className='beep-row'>
                            <div>بوق زدن</div>
                            <Button className='beep-btn' onClick={() => playBeep()}>
                                <img src={ring} alt="" />

                            </Button>
                        </Row>

                        {/*{lockButton}*/}
                    </Col>
                </Panel>
            </Collapse>

            <Row className='px-40' justify="center">

            </Row>
            <Row className='px-40'>
                <Button type="primary" className='m-1' block shape="round" size='large'
                    onClick={showConfirmFinish} disabled={confirmFinish}>
                    پایان سفر
                </Button>
            </Row>
        </div>
        <Map
            vehicles={vehiclesPos}
            position={defaultPos}
            zoomLevel={zoomLevel}
            forceFollowUser />
    </>
}